import {  NgModule } from '@angular/core';
import { VisualizadorRoutingModule } from './visualizador.routing.module';

import { 
  VisualizadorComponent
} from './index.component';
import { SharedModule } from '@smdapp/shared';
import { NgSharedModule } from '@smdapp/ng-shared/ng-shared.module'
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [VisualizadorRoutingModule, NgSharedModule, SharedModule, CommonModule],
  declarations: [
    VisualizadorComponent
  ]
})
export class VisualizadorModule {}
